import React from 'react';

import { Box, Grid, Typography } from '@mui/material';
import { PricingType } from '@prisma/client';

import OffersCard from '../../components/PricingInformation/OffersCard/OffersCard';
import OffersContainer from '../../components/PricingInformation/OffersContainer/OffersContainer';

import { addPartnerSummaryProps } from './step1_PartnerType';

export const PricingInformation: React.FC<addPartnerSummaryProps> = ({ formSummaryData }) => {
    return (
        <Grid item xs={12} sx={{ padding: '32px 24px' }} container>
            <Grid item xs={12} sx={{ borderBottom: '1px solid #F18F34', marginBottom: '24px' }}>
                <Box display="flex" flexDirection="column" gap="8px">
                    <Typography sx={{ fontSize: '24px', fontWeight: 500 }}>
                        Pricing Information
                    </Typography>
                </Box>
            </Grid>

            <Grid container spacing={3}>
                <Grid item xs={12} md={5.5}>
                    <OffersContainer title="Terminal Offers">
                        <OffersCard title="Assigned Offers">
                            <Box
                                sx={{
                                    mt: 1,
                                    width: '95%',
                                    height: '255px',
                                    overflowY: 'scroll',
                                }}
                            >
                                {formSummaryData &&
                                    formSummaryData?.assignedOffers
                                        ?.filter((offer) => offer?.type === PricingType.TERMINAL)
                                        ?.map((offer, index) => (
                                            <Typography
                                                key={index}
                                                sx={{
                                                    fontSize: '18px',
                                                    p: 1,
                                                    ml: 1.5,
                                                    cursor: 'pointer',
                                                    color: '#F39E4E',
                                                }}
                                            >
                                                {offer?.name}
                                            </Typography>
                                        ))}
                            </Box>
                        </OffersCard>
                    </OffersContainer>
                </Grid>

                <Grid item xs={12} md={5.5}>
                    <OffersContainer title="Online Offers">
                        <OffersCard title="Assigned Offers">
                            <Box
                                sx={{
                                    mt: 1,
                                    width: '95%',
                                    height: '255px',
                                    overflowY: 'scroll',
                                }}
                            >
                                {formSummaryData &&
                                    formSummaryData?.assignedOffers
                                        ?.filter((offer) => offer?.type === PricingType.ONLINE)
                                        ?.map((offer, index) => (
                                            <Typography
                                                key={index}
                                                sx={{
                                                    fontSize: '18px',
                                                    p: 1,
                                                    ml: 1.5,
                                                    cursor: 'pointer',
                                                    color: '#F39E4E',
                                                }}
                                            >
                                                {offer?.name}
                                            </Typography>
                                        ))}
                            </Box>
                        </OffersCard>
                    </OffersContainer>
                </Grid>

                <Grid item xs={12} md={5.5}>
                    <OffersContainer title="Transactions Offers">
                        <OffersCard title="Assigned Offers">
                            <Box
                                sx={{
                                    mt: 1,
                                    width: '95%',
                                    height: '255px',
                                    overflowY: 'scroll',
                                }}
                            >
                                {formSummaryData &&
                                    formSummaryData?.assignedTransactionOffers?.map(
                                        (offer, index) => (
                                            <Typography
                                                key={index}
                                                sx={{
                                                    fontSize: '18px',
                                                    p: 1,
                                                    ml: 1.5,
                                                    cursor: 'pointer',
                                                    color: '#F39E4E',
                                                }}
                                            >
                                                {offer?.offerName}
                                            </Typography>
                                        )
                                    )}
                            </Box>
                        </OffersCard>
                    </OffersContainer>
                </Grid>
            </Grid>
        </Grid>
    );
};
